
import { ICategoryAdmin } from '../interfaces/ICategoryAdmin';

import { Environment } from './Environment';
import { FetchProxy } from 'intraactive-sdk-helper';
import { sdkContainerInstance } from '../global/Container';
import { IEnvironment } from '../interfaces/IEnvironment';

export default class CategoryService {

  public static getCategories(environment: IEnvironment, instance: string, tenantName: string, token: string, site: string, application: string): Promise<ICategoryAdmin[]> {
    return new Promise<ICategoryAdmin[]>((resolve: (list: ICategoryAdmin[]) => void, reject: (error: any) => void): void => {
      if (environment && instance && token && site && application) {
        if (site === "IntraActive-Messages") {
          new FetchProxy(`${Environment.getEnvironmentForMessagesAPI(environment)}/${tenantName}/${instance}/categories/`, { method: "GET", headers: { 'AuthToken': token } })
            .withContainer(sdkContainerInstance)
            .fetch()
            .then((response) => {
              if (!response.ok) {
                reject(response);
                return;
              }
              return response.json().then((jsonResponse: any[]) => {
                if (jsonResponse && jsonResponse[0] && jsonResponse[0].iaMessageCategoryData) {
                  jsonResponse[0].data = jsonResponse[0].iaMessageCategoryData;
                  delete jsonResponse[0].iaMessageCategoryData;
                }
                resolve(jsonResponse);
              });
            })
            .catch(error => {
              console.log(error);
              reject(null);
            });
        } else {
          new FetchProxy(`${Environment.getEnvironmentForCategoriessAPI(environment)}/${tenantName}/${instance}?site=${site}&application=${application}`, { method: "GET", headers: { 'AuthToken': token } })
            .withContainer(sdkContainerInstance)
            .fetch()
            .then((response) => {
              if (!response.ok) {
                reject(response);
                return;
              }
              return response.json().then((jsonResponse: ICategoryAdmin[]) => {
                resolve(jsonResponse);
              });
            })
            .catch(error => {
              console.log(error);
              reject(null);
            });
        }
      } else {
        reject(null);
      }
    });
  }

  public static syncTerms(environment: IEnvironment, instance: string, tenantName: string, token: string, termGroup: string, termSet: string, site: string, application: string): Promise<any> {
    return new Promise<ICategoryAdmin[]>((resolve: (list: any) => void, reject: (error: any) => void): void => {
      if (environment && instance && tenantName && token && termGroup && termSet && site && application) {
        if (site === "IntraActive-Messages") {
          new FetchProxy(`${Environment.getEnvironmentForMessagesAPI(environment)}/${tenantName}/${instance}/categories/sync?termGroup=${termGroup}&termSet=${termSet}`, { method: "POST", headers: { 'AuthToken': token } })
            .withContainer(sdkContainerInstance)
            .fetch()
            .then((response) => {
              if (!response.ok) {
                reject(response);
                return;
              }
              return resolve(response);
            })
            .catch(error => {
              console.log(error);
              reject(null);
            });
        } else {
          new FetchProxy(`${Environment.getEnvironmentForCategoriessAPI(environment)}/${tenantName}/${instance}/sync?termGroup=${termGroup}&termSet=${termSet}&site=${site}&application=${application}`, { method: "POST", headers: { 'AuthToken': token } })
            .withContainer(sdkContainerInstance)
            .fetch()
            .then((response) => {
              if (!response.ok) {
                reject(response);
                return;
              }
              return resolve(response);
            })
            .catch(error => {
              console.log(error);
              reject(null);
            });
        }
      } else {
        reject(null);
      }
    });
  }

  public static unsyncCategories(environment: IEnvironment, instance: string, tenantName: string, token: string, site: string, application: string): Promise<any> {
    return new Promise<ICategoryAdmin[]>((resolve: (list: any) => void, reject: (error: any) => void): void => {
      if (environment && instance && tenantName && token && site && application) {
        if (site === "IntraActive-Messages") {
          new FetchProxy(`${Environment.getEnvironmentForMessagesAPI(environment)}/${tenantName}/${instance}/categories/unsync`, { method: "GET", headers: { 'AuthToken': token } })
            .withContainer(sdkContainerInstance)
            .fetch()
            .then((response) => {
              if (!response.ok) {
                reject(response);
                return;
              }
              return resolve(response);
            })
            .catch(error => {
              console.log(error);
              reject(null);
            });
        } else {
          new FetchProxy(`${Environment.getEnvironmentForCategoriessAPI(environment)}/${tenantName}/${instance}/unsync?site=${site}&application=${application}`, { method: "GET", headers: { 'AuthToken': token } })
            .withContainer(sdkContainerInstance)
            .fetch()
            .then((response) => {
              if (!response.ok) {
                reject(response);
                return;
              }
              return resolve(response);
            })
            .catch(error => {
              console.log(error);
              reject(null);
            });
        }
      } else {
        reject(null);
      }
    });
  }

  public static getTermsAvailable(environment: IEnvironment, siteRef: string, tenantName: string, token: string): Promise<any[]> {
    return new Promise<any[]>((resolve: (termsAvailable: any[]) => void, reject: (error: any) => void): void => {
      if (environment && siteRef && tenantName && token) {
        const body = {
          tenantRef: `${tenantName}.sharepoint.com`,
          siteRef: siteRef
        };
        const apiUrl: string = `${Environment.getEnvironmentForMainAPI(environment)}/api/targeting/getTermsAvailable?tenantRef=${encodeURIComponent(body.tenantRef)}&siteRef=${encodeURIComponent(body.siteRef)}`;
        new FetchProxy(apiUrl, { method: "GET", credentials: "same-origin", headers: { 'AuthToken': token } })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              reject(response);
              return;
            }
            return response.json();
          }).then(result => {
            resolve(result);
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        reject(null);
      }
    });
  }

  public static updateMessageCategories(environment: IEnvironment, instance: string, tenantName: string, token: string, category: ICategoryAdmin): Promise<any> {
    return new Promise<ICategoryAdmin[]>((resolve: (list: any) => void, reject: (error: any) => void): void => {
      if (environment && instance && tenantName && token) {
        new FetchProxy(`${Environment.getEnvironmentForMessagesAPI(environment)}/${tenantName}/${instance}/categories?id=${category.id}`,
        { 
          method: "PUT",
          headers: {
            'AuthToken': token
          },
          body: JSON.stringify(category)
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              reject(response);
              return;
            }
            return resolve(response);
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        reject(null);
      }
    });
  }

  public static updateEventCategories(environment: IEnvironment, instance: string, tenantName: string, category: ICategoryAdmin): Promise<any> {
    return new Promise<ICategoryAdmin[]>((resolve: (list: any) => void, reject: (error: any) => void): void => {
      if (environment && instance && tenantName && category?.id) {
        new FetchProxy(`${Environment.getEnvironmentForCategoriessAPI(environment)}/${tenantName}/${instance}/${category.id}?site=IntraActive-Events`,
        { 
          method: "PUT",
          body: JSON.stringify(category)
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              reject(response);
              return;
            }
            return resolve(response);
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        reject(null);
      }
    });
  }
}